export function replaceNormalPlaceholder({ text, replacement = "" }) {
  let regex = new RegExp("{{placeholder}}", "gi");
  return text.replace(regex, replacement.toLowerCase());
}

export function upperCaseFirstLetter(text = "") {
  return `${text[0].toUpperCase()}${text.slice(1)}`;
}
